import { useEffect, useState } from "react";
import { getSocket } from "@/sockets/socket";

export type SocketStatus = "connected" | "connecting" | "disconnected";

/** Tracks connect/disconnect/reconnect state for the shared socket, for a header indicator. */
export function useSocketStatus(): SocketStatus {
  const [status, setStatus] = useState<SocketStatus>(
    getSocket().connected ? "connected" : "disconnected",
  );

  useEffect(() => {
    const socket = getSocket();
    const onConnect = () => setStatus("connected");
    const onDisconnect = () => setStatus("disconnected");
    const onReconnectAttempt = () => setStatus("connecting");

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);
    socket.io.on("reconnect_attempt", onReconnectAttempt);

    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
      socket.io.off("reconnect_attempt", onReconnectAttempt);
    };
  }, []);

  return status;
}
